import $ from 'jquery';
import {onResize, onScroll} from "../utils/window";
import {urlParams} from "../utils/url";

export default function productPage() {
	const $html = $('html');
	const $scroller = $('html, body');

	const $product = $('.product');

	function setupStickySidebar() {
		const stickySidebar = $('.product-details-key[sw-sticky]');
		stickySidebar.each(function () {
			const $this = $(this);
			let $el = $this;

			$this.css('width', '');

      $this.addClass('-stop');
      
			if (stickySidebar.hasClass('is-stuck')) {
				$el = $el.prev();
			}

			$this.css('width', $el.outerWidth() + 'px');
		});
	}

	function setupStickySidebarScroll() {

		const $key = $('.product-details-key.is-stuck');
		const $container = $('.product-container');

		if ($key.length) {

			let $containerOffset = $container.offset().top + $container.outerHeight();
			let $keyOffset = $key.offset().top + $key.outerHeight();

			if ($key.hasClass('-stop')) {
				if ($(document).scrollTop() < $key.offset().top) {
					$key.removeClass('-stop');
				}
			} else {
				if (($keyOffset - 50) > $containerOffset) {
					$key.addClass('-stop');
				}
			}
		}
	}

	function setupProductSmallCards() {
		const cards = $('.card.-style-product-small .card_content');

		cards.each(function () {
			const $this = $(this);
			$this.css('min-height', $this.outerWidth() + 'px');
		});
	}

	function setupOverCards() {
		const $cards = $('.card.-style-over');

		if ($cards.length) {
			$cards.each(function () {
				const $body = $(this).find('.card_content_body');
				let height = 0;

				$body.attr('style', 'height: auto !important;');
				height = $body.outerHeight();
				$body.attr('style', `height: ${height}px`);
			});
		}
	}

	function setupPrint() {
		const printEls = $('[sw-print]');

		if (printEls.length) {
			const spinner = $('.product-summary_print-spinner');
			printEls.on('click', function () {
				const $this = $(this);
				const url = $this.attr('data-action'), slug = $this.attr('sw-print'), time = $this.attr('data-time');
				spinner.addClass('is-open');
				$.get({
					url: url,
					data: {
						slug: slug,
						time: time
					}
				}, function (data){
					let decoded = JSON.parse(data);
					if (decoded.success) {
						window.open(decoded.url, '_blank');
					} else {
						alert('An error has occurred while trying to get the brochure. Please try again later.');
					}

					spinner.removeClass('is-open');
				});
			});
		}
	}

	function setupCTCW() {
		const $ctcw = $('.product-ctcw');

		if ($ctcw.length) {
			const $button = $ctcw.find('.product-t-is-l_button');
			const $parent = $button.parent();
			const $container = $ctcw.find('.product-t-is-s-container');
			let offset = $button.data('offset');
			const id = $button.data('id');
			const entry = $button.data('entry');
			const url = $button.data('url');

			$button.click(function (e) {
				$parent.addClass('-loading');

				$.get(url, { entry: entry, offset: offset, id: id }, function (data) {
					if ($(data).length) {
						$container.append(data);
						$parent.removeClass('-loading');
						setUpOrderVariables();
					} else {
						$parent.css('display', 'none');
					}
					offset++;
				});
			});
		}
	}

	function resizeCall() {
		setupStickySidebar();
		setupProductSmallCards();
		setupOverCards();
	}

	function setUpOrderVariables () {
		const searchParams = window.location.search.replace('?', '');
		const queryObj = urlParams(searchParams);
		const arr = [
			{
				name: 'OpportunityID',
				handle: 'crmOpportunityId'
			},
			{
				name: 'ContactID',
				handle: 'crmContactId'
			},
			{
				name: 'CustomerID',
				handle: 'crmCustomerId'
			}];

		let inputs = [];
		const productForms = document.querySelectorAll('form.product-t-is-s.-item:not(.updated)');

		if (window.NodeList && !NodeList.prototype.forEach) {
			NodeList.prototype.forEach = Array.prototype.forEach;
		}

		if (window.NodeList && !NodeList.prototype.forEach) {
			NodeList.prototype.forEach = function (callback, thisArg) {
				thisArg = thisArg || window;
				for (let i = 0; i < this.length; i++) {
					callback.call(thisArg, this[i], i, this);
				}
			};
		}

		arr.forEach(val => {
			let input = createParamInput(val, queryObj);
			if (input) {
				inputs.push(input);
			}
		});

		if (inputs.length) {
			productForms.forEach((form, index) => {
				inputs.forEach(el => {
					form.append(el.cloneNode());
				});

				form.classList.add('updated');

        let simple = document.createElement('input');
        simple.setAttribute('type', 'hidden');
        simple.setAttribute('name', 'fields[isSimpleWorkflow]');
        simple.setAttribute('value', 1);
        form.append(simple.cloneNode());
			});
		}
	}

	function createParamInput(val, query) {
		let input = null;
		if (query.hasOwnProperty(val.name)) {
			input = document.createElement('input');
			input.setAttribute('type', 'hidden');
			input.setAttribute('name', `fields[${val.handle}]`);
			input.setAttribute('value', `ID:${query[val.name]}`);
		}

		return input;
	}

	if ($product.length) {
		const $accordionButtons = $('.pSec-content.-accordion > .pSec_toggler');

		$accordionButtons.each(function () {
			const _this = $(this);
			const $parent = _this.parent();
			const parentHeight = $parent.outerHeight();

			$parent.css('height', '250px');

			_this.click(function (e) {
				if (!$parent.hasClass('is-open')) {
					$parent.addClass('is-open');
					_this.html('- Show Less');

					$parent.animate({
						height: parentHeight
					}, 400, function () {
						$parent.css('height', '');
					});
				} else {
					$parent.removeClass('is-open');
					_this.html('+ Show More');

					$parent.animate({
						height: 250
					}, 400);
				}
			})
		});

		setupPrint();
		resizeCall();
		setupCTCW();
		setUpOrderVariables();
		onResize(resizeCall);
		onScroll(setupStickySidebarScroll);
	} else {
		setupOverCards();
		setupProductSmallCards();
		onResize(function () {
			setupProductSmallCards();
			setupOverCards();
		});
	}
}



// WEBPACK FOOTER //
// ./source/scripts/pages/product.js